export default "__VITE_ASSET__57e9f8dc__"